<template>
    <div>
        <survey-analytics :survey="survey"></survey-analytics>
        <div class="survey-page">
            <div class="survey-header tw-flex tw-justify-between tw-items-center" style="margin-bottom: 10px">
                <div>
                    <h4 style="margin-bottom: 0">Public Survey Page</h4>
                    <span class="tw-inline-block tw-mt-2">This is a link to your public survey fill out page. You can share it with anyone to fill out your survey directly.</span>
                </div>
                <div class="ws-filter tw-flex tw-flex-row">
                    <span class="text-small">Enable public survey fill out page?</span>
                    <div class="ws-filter-switch" :data-state="(survey.active) ? 'yes' : 'no'" @click="onTogglePublishedStatus">
                        <div class="ws-filter-switch-knob"></div>
                    </div>
                </div>
            </div>
            <div class="survey-info">
                <div class="page-url tw-relative">
                    <input type="text" :value="survey.publicUrl" readonly class="tw-w-full">
                </div>
                <div class="tw-flex tw-justify-between" style="margin-top: 20px">
                    <div>
                        <copy-btn :value="survey.publicUrl" class="ws-button">Copy Public Survey Page Link</copy-btn>
                        <a target="_blank" class="ws-button ws-button-secondary" :href="survey.publicUrl+'?preview'">Preview Survey</a>
                    </div>
                    <div>
                        <div class="ws-button ws-button-secondary" @click="onShowSettings">Survey Settings</div>
                    </div>
                </div>
            </div>
        </div>
        
        <modal v-if="showSourceModal" @close="onCloseSourceForm">
            <survey-source-form :source="selectedSource" :error="error" @save="onSaveSource" @cancel="onCloseSourceForm"/>
        </modal>
        <modal v-if="showSettingsModal" @close="showSettingsModal = false">
            <h3 v-if="surveySettingsFormType==='activated-template'">Survey Template Activated</h3>
            <h3 v-else>Survey Settings</h3>
            <survey-settings-form :survey="survey" :error="error" :type="surveySettingsFormType" @save="onUpdateSettings" @cancel="showSettingsModal = false"/>
        </modal>

        <div class="survey-sources tw-mt-8">
            <h3 class="tw-text-lg">Survey Sources <div class="ws-button" @click="onNewSource">Create A New Source</div></h3>
            <div class="tw-mt-4">
                <table class="worksends-table table-auto">
                    <thead>
                        <tr>
                            <th class="field-name">Source Name</th>
                            <th class="field-status">Status</th>
                            <th class="field-views">Views</th>
                            <th class="field-replies">Replies</th>
                            <th class="field-actions">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="source in sources" :key="source.id" :data-type="source.type" :data-platform="source.platform">
                            <td class="field-name">{{ source.name }}</td>
                            <td class="field-status">
                                <span v-if="source.active" class="status active">Active</span>
                                <span v-if="!source.active" class="status draft">Disabled</span>
                                <copy-btn v-if="source.active" :value="source.public_url"
                                        class="ws-button small tw-ml-3">
                                    Copy Url
                                </copy-btn>
                            </td>

                            <td class="field-views number"><b>{{ source.responses_count || 0 }}</b></td>
                            <td class="field-replies number">
                                <span><b>{{ source.complete_responses_count || 0 }}</b></span>
                                <span> ({{ source.responses_count ? Math.round(source.complete_responses_count / source.responses_count * 100) : 0 }}%)</span>
                            </td>
                            <td class="field-actions tw-whitespace-nowrap">
                                <div class="ws-button small"
                                        @click="$router.push({
                                        name: 'surveys-details-results',
                                        params: {survey_id: survey.id},
                                        query: {source: source.id},
                                        })"
                                >Results
                                </div>
                                <div class="ws-button small"
                                        @click="$router.push({
                                        name: 'surveys-details-responses',
                                        params: {survey_id: survey.id},
                                        query: {source: source.id},
                                        })"
                                >Responses
                                </div>
                                <div class="ws-button small ws-button-secondary" @click="onEditSource(source)">
                                    Settings
                                </div>
                            </td>
                        </tr>
                        <tr key="public-url-source" data-type="public-url-source">
                            <td class="field-name"><i>Public Survey Page</i></td>
                            <td class="field-status">
                                <span v-if="survey.active" class="status active">Active</span>
                                <span v-if="!survey.active" class="status draft">Draft</span>
                            </td>
                            <td class="field-views number"><b>{{ survey.public_url_views || 0 }}</b></td>
                            <td class="field-replies number"><b>{{ survey.public_url_replies || 0 }}</b> ({{ Math.round(survey.public_url_replies / survey.public_url_views * 100) || 0 }}%)</td>
                            <td class="field-actions tw-w-40 tw-whitespace-nowrap">
                                <div class="ws-button small"
                                        @click="$router.push({name: 'surveys-details-results', params: {survey_id: survey.id} })">
                                    Results
                                </div>
                                <div class="ws-button small"
                                        @click="$router.push({name: 'surveys-details-responses', params: {survey_id: survey.id} })"
                                >Responses
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="sources-count text-small"><i>This survey has {{ sources.length + 1 }} {{ ((sources.length + 1) > 1) ? 'sources' : 'source' }}.</i></div>
            </div>
        </div>

    </div>

</template>

<script>
import CopyBtn from "@/components/CopyBtn";
import SurveySourceForm from "@/pages/surveys/SurveySourceForm";
import Modal from "@/components/modals/Modal";
import SurveySettingsForm from "@/pages/surveys/SurveySettingsForm";
import SurveyAnalytics from "@/pages/surveys/SurveyAnalytics.vue";

export default {
    name: 'SurveyDetailsSummary',
    components: {SurveyAnalytics, SurveySettingsForm, Modal, SurveySourceForm, CopyBtn},
    data() {
        return {
            showSourceModal: false,
            showSettingsModal: false,
            surveySettingsFormType: 'standard',
            error: undefined
        }
    },
    computed: {
        survey() {
            return this.$store.getters["surveys/selected"];
        },
        sources() {
            return this.$store.getters['surveySources/orderedList']
        },
        selectedSource() {
            return this.$store.getters['surveySources/selected']
        },
    },
    beforeRouteUpdate(to) {
        this.fetchSurvey(to.params.survey_id);
    },
    async created() {
        await this.fetchSurvey(this.$route.params.survey_id);
        if (this.$route.meta?.fromTemplate && !localStorage.getItem(`activated-survey-template-${this.$route.params.survey_id}`)) {
            this.surveySettingsFormType = 'activated-template';
            this.showSettingsModal = true;
            localStorage.setItem(`activated-survey-template-${this.$route.params.survey_id}`, 'true');
        }
    },
    methods: {
        async fetchSurvey() {
            await this.$store.dispatch('surveySources/getList', {});
        },
        async onTogglePublishedStatus() {
            await this.$store.dispatch(this.survey.active ? 'surveys/unpublish' : 'surveys/publish', this.survey)
        },
        onNewSource() {
            this.$store.commit('surveySources/setSelected', undefined);
            this.showSourceModal = true;
        },
        onShowSettings() {
            this.surveySettingsFormType = 'standard';
            this.showSettingsModal = true;
        },
        async onSaveSource(data) {
            let response = {};
            try {
                if (this.selectedSource) {
                    response = await this.$store.dispatch('surveySources/update', data);
                } else {
                    response = await this.$store.dispatch('surveySources/create', data);
                }
            } catch(error) {
                this.error = error.response.data;
                return;
            }
            if (data.active && !response.active) await this.onActivateSource(response);
            if (!data.active && response.active && this.selectedSource) await this.onDeactivateSource(response);
            this.$store.commit('surveySources/setSelected', undefined);
            this.error = undefined;
            this.showSourceModal = false;
        },
        onCloseSourceForm() {
            this.error = undefined;
            this.showSourceModal = false;
            this.$store.commit('surveySources/setSelected', undefined);
        },
        async onUpdateSettings(changes) {
            try { await this.$store.dispatch('surveys/update', changes) }
            catch(error) {
                this.error = error.response.data;
                return;
            }
            this.$store.commit('surveySources/setSelected', undefined);
            this.showSettingsModal = false;
        },
        onEditSource({id}) {
            this.$store.commit('surveySources/setSelected', id);
            this.showSourceModal = true;
        },
        async onDeactivateSource({id}){
            this.$store.dispatch('surveySources/unpublish', id);
        },
        async onActivateSource({id}){
            this.$store.dispatch('surveySources/publish', id);
        },
    },
}
</script>
